import script from "./ClientsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsSection.vue?vue&type=script&setup=true&lang=js"

import "./ClientsSection.vue?vue&type=style&index=0&id=6d1f3fa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1f3fa8"]])

export default __exports__